export default import.meta.ROLLDOWN_FILE_URL_n3djTMNIRODKNkWuVgbHmQ